import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

import { useBffClient } from 'src/app/hooks/data/useBffClient';

interface FirstAttemptRetrievalResponse {
  retrievalId: number;
  taskId: number;
}

interface CreateFirstAttemptRetrievalParams {
  prescriptionId: number;
  userId: number;
}

export const useCreateFirstAttemptRetrieval = (): UseMutationResult<
  FirstAttemptRetrievalResponse,
  AxiosError,
  Partial<CreateFirstAttemptRetrievalParams>
> => {
  const authClient = useBffClient();

  return useMutation(
    ({ prescriptionId, userId }) =>
      authClient
        .post(
          `retrieval/reactive/first_attempt`,
          {
            prescriptionId,
            userId,
            ctaVariant: 'B',
          },
          { headers: { 'Content-Type': 'application/json' } }
        )
        .then((resp: { data: FirstAttemptRetrievalResponse }) => resp.data),
    {}
  );
};
